import React, {useState} from "react";
import DataDevis from "../dataDevis";
import logo_eco from "../img/Logo eco by assur bon plan.png"
import logo_abp from "../img/Logo assur bon plan.png"
import question_mark from "../img/questionmark.png"

const TarifRow = (p) => {

    const {oneColumn,solly,xena,formule,periodicite,changeParams,detailSwitch} = p.container
    const w = xena.find( w => w.Z_FORM==p.xenaKey )
    return <tr><td onClick={()=>detailSwitch(p.xenaKey)}>{p.children}
        </td><td 
            className={(( formule==p.xenaKey )&&( periodicite == 'A'))?'tarif selected':'tarif'}
            onClick={()=>{ changeParams({'formule':p.xenaKey,'periodicite':'A'}) }}
        >
        { ( w && +w.Z_MTAN )? <>
            {DataDevis.fancyPrice(w.Z_MTAN)} €
        </> :<i>Non disponible</i>}
        </td><td 
            className={(( formule==p.xenaKey )&&( periodicite == 'M'))?'tarif selected':'tarif'}
            onClick={()=>{ changeParams({'formule':p.xenaKey,'periodicite':'M'}) }}
        >
        { ( w && +w.Z_MTMENS ) ? <>
            {DataDevis.fancyPrice(w.Z_MTMENS)} €<sup>*</sup>
        </> :<i>Non disponible</i>}
        </td>
    </tr>
}


const DetailRow = (p) => {
    return p.unfold.includes(p.xenaKey) ? <tr><td className="formule_details" colSpan="3">{p.children}</td></tr> : <></>
}

export default class FrontTarifsAlone extends React.Component {
    
    constructor(props) {
        super(props);
        this.ref = React.createRef()
        this.state = {
            unfold:[],
            M2:false,
            M3:false,
            M4:false,
            M7:false
        }
    }

    detailSwitch(code,specific=false) {
        if ( this.state.unfold.includes(code) ) {
            if ( this.state[code] == specific ) {
                this.setState({unfold:this.state.unfold.filter(c=>c!=code)})
            } else {
                this.setState({[code]:specific})
            }
        } else {
            this.setState({unfold:[code,...this.state.unfold],[code]:specific})
        }
    }

    renderDetails( zForm ) {
        return DataDevis.zFormToDetailsAlone[zForm]
    }

    render() {
        const {devis,solly,oneColumn,focusError,showValidate,changeParams} = this.props.container
        const isMoto = devis.type=='moto'
        const {params} = devis
        const {periodicite,formule} = params
        const container = {
            xena:params.warranties,
            solly:solly,
            oneColumn:oneColumn,
            periodicite:periodicite,
            formule:formule,
            changeParams:changeParams,
            detailSwitch:this.detailSwitch.bind(this)
        }

        if ( !params.warranties ) return <></>

        let message = devis.validateMessage('formule')
        if ( !message ) message = devis.validateMessage('periodicite')
        if ( message ) focusError(this.ref)
        if ( !showValidate ) message = undefined

        return <><table ref={this.ref} className="comparateur gradiant onecolumn">
                <thead>
                    <tr><th></th><th>Tarif TTC Annuel<br/>(x1)</th><th>Tarif TTC Mensuel<br/>(x12)</th></tr>
                </thead>
                <tbody>
                    {isMoto ? <>
                        <TarifRow xenaKey="M2" container={container}>
                            <h3>Formule <b>au Tiers</b>
                            <img src={question_mark}/></h3>
                            Responsabilité Civile et Défense Pénale et Recours Suite à Accident
                        </TarifRow>
                        <DetailRow xenaKey="M2" unfold={this.state.unfold} oneColumn={oneColumn}>
                            {this.renderDetails('M2')}
                        </DetailRow>
                        <TarifRow xenaKey="M3" container={container}>
                            <h3>Formule <b>Tiers + Vol & Incendie</b><img src={question_mark}/></h3>
                            Catastrophes Naturelles, Catastrophes
                            Technologiques, attentats, Garantie valeur à neuf,
                            garantie caques et gants, protection juridique
                        </TarifRow>
                        <DetailRow xenaKey="M3" unfold={this.state.unfold} oneColumn={oneColumn}>
                            {this.renderDetails('M3')}
                        </DetailRow>
                        <TarifRow xenaKey="M4" container={container}>
                            <h3>Formule Vol + <b>Dommage Collision</b><img src={question_mark}/></h3>
                            Accident avec un tiers identifié
                        </TarifRow>
                        <DetailRow xenaKey="M4" unfold={this.state.unfold} oneColumn={oneColumn}>
                            {this.renderDetails('M4')}
                        </DetailRow>
                        <TarifRow xenaKey="M7" container={container}>
                            <h3>Formule <b>Tous risques</b><img src={question_mark}/></h3>
                            Dommages tous accidents
                        </TarifRow>
                        <DetailRow xenaKey="M7" unfold={this.state.unfold} oneColumn={oneColumn}>
                            {this.renderDetails('M7')}
                        </DetailRow>
                    </>:<>

                    <TarifRow xenaKey="L1" container={container}>
                            <h3>Formule <b>au Tiers</b>
                            <img src={question_mark}/></h3>
                            Responsabilité Civile et Défense Pénale et Recours Suite à Accident
                        </TarifRow>
                        <DetailRow xenaKey="L1" unfold={this.state.unfold} oneColumn={oneColumn}>
                            {this.renderDetails('L1')}
                        </DetailRow>
                        <TarifRow xenaKey="L2" container={container}>
                            <h3>Formule <b>Tiers + Vol & Incendie et Bris de Glace</b><img src={question_mark}/></h3>
                        </TarifRow>
                        <DetailRow xenaKey="L2" unfold={this.state.unfold} oneColumn={oneColumn}>
                            {this.renderDetails('L2')}
                        </DetailRow>
                        <TarifRow xenaKey="L3" container={container}>
                            <h3>Formule <b>Tous risques</b><img src={question_mark}/></h3>
                            Dommages tous accidents
                        </TarifRow>
                        <DetailRow xenaKey="L3" unfold={this.state.unfold} oneColumn={oneColumn}>
                            {this.renderDetails('L3')}
                        </DetailRow>
                    </>}
                </tbody>
            </table>
            <div className="price_notice">* Prix mensuel, auquel s'ajoutent <b>{devis.fees()} €</b> de frais de gestion et de courtage à payer à la souscription, renouvelables tous les ans.</div>
        </>
    }
}